import { MdWorkOutline, MdOutlineCalendarMonth } from "react-icons/md";


export const historyConf = {
    "datetimeField": "created_at",
    "showInfo": [
        {
            "icon": <MdWorkOutline className="icon" />,
            "field": "contribuente"
        },
        {
            "icon": <MdOutlineCalendarMonth className="icon" />,
            "field": "doc_payment_date"
        }
    ]
};
